import './assets/scss/dashboard.scss'

export default {
  install() {},
}
